import React, { useEffect, useState } from 'react'
import { Alert, Button, Drawer, Icon, Input, Modal, Tooltip } from 'antd'
import moment from 'moment'
import { getAssessmentActivityFxn, getCallbackFxn, getSingleAssessmentFxn } from '../action'
import { useDispatch } from 'react-redux'
import AddAssessment from './addAssessment'
import NotEligibleAssessment from './notEligibleDrawer'
import { adminRightUser } from '../../../components/_utils/appUtils'

let addAssessmentInit = {
  visible: false,
  assessmentId: '',
  countryId: ''
}
let notEligibleAssessmentInit = {
  visible: false,
  assessmentId: ''
}
const AssessmentProfile = (props) => {
  let { visible, onClose, assessmentData, currentUser } = props
  let dispatch = useDispatch()
  let [requestCallBack, setRequestCallBack] = useState([])
  let [assessmentActivity, setAssessmentActivity] = useState([])
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [cancelReason, setCancelReason] = useState('')
  const [addAssessmentVisible, setAddAssessmentVisible] = useState(addAssessmentInit)
  const [addNotEligibleVisible, setNotEligibleVisible] = useState(notEligibleAssessmentInit)
  let [singleAssessment, setSingleAssessment] = useState({})
  useEffect(() => {
    if (assessmentData._id) {
      assEvents.refreshData()
    }
  }, [assessmentData._id])


  const assEvents = {
    showAddAssessmentDrawer: (assessment) => {
      setAddAssessmentVisible({
        visible: true,
        assessmentId: assessmentData._id,
        countryId: assessmentData.countryId
      })
    },
    hideAddAssessmentDrawer: () => {
      setAddAssessmentVisible({
        visible: false,
        assessmentId: '',
        countryId: ''
      })
    },
    showNotEligibleAssessmentDrawer: () => {
      setNotEligibleVisible({
        visible: true,
        assessmentId: assessmentData._id
      })
    },
    hideNotEligibleAssessmentDrawer: () => {
      setNotEligibleVisible({
        visible: false,
        assessmentId: ''
      })
    },
    openDocument: (path) => {
      window.open(path, '_blank')
    },


    refreshData: () => {
      getAssessmentActivityEvent()
      getSingleAssessmentEvent()
    }
  }
  const getSingleAssessmentEvent = async () => {
    try {
      let { data } = await dispatch(getSingleAssessmentFxn({ assessmentId: assessmentData._id }))
      setSingleAssessment(data)
    } catch (err) {
    }
  }
  const getCallbackStatusFxn = async () => {
    try {
      let data = await dispatch(getCallbackFxn(assessmentData._id))
      setRequestCallBack(data.requestCallBack)
      setAssessmentActivity(data.assessmentActivity)
    } catch (err) {
    }
  }
  const getAssessmentActivityEvent = async () => {
    try {
      let { data } = await dispatch(getAssessmentActivityFxn({ assessmentId: assessmentData._id }))
      setAssessmentActivity(data)
    } catch (err) {
    }
  }
  useEffect(() => {
    if (assessmentData && assessmentData._id) {
      getCallbackStatusFxn()
    }
  }, [assessmentData])

  const closeFxn = () => {
    onClose(assessmentData)
  }

  return (
    <Drawer
      visible={visible}
      width={'45%'}
      placement='right'
      closable={false}
      bodyStyle={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}
      onClose={closeFxn}>
      <div style={{ flex: 1, overflowY: 'auto' }} className='p-4'>
        <div className='p-4 mb-4 assessment_profile_card'>
          <a className={'cross_btn'} onClick={closeFxn}>
            <Tooltip title={'Delete'}>
              <Icon type={'close'} />
            </Tooltip>
          </a>
          <div className={'jcsb assessment-info-box'}>
            <div>
              <h3 className={'person-name'}>
                {singleAssessment && singleAssessment.contactPersonName}
              </h3>
              DOB: {moment(singleAssessment && singleAssessment.dateOfBirth).format('DD-MM-YYYY')}{'  '} •
              Passport: {singleAssessment && singleAssessment.passportNumber}
            </div>
            <div>
              {['pending', 'viewed'].includes(singleAssessment && singleAssessment.status) && (
                <a className={'btn'}
                   onClick={() => assEvents.showAddAssessmentDrawer(singleAssessment)}>
                  <Icon type={'plus'} />
                </a>
              )}
            </div>
          </div>

          <div className={'document_box'}>
            {singleAssessment && singleAssessment.documents && singleAssessment.documents.length && singleAssessment.documents.map((item, index) => {
              return (
                <>
                  <div key={index} className='doc-preview-card pCursor' onClick={() => {
                    assEvents.openDocument(item.path)
                  }}>
                    <img src='../images/google-docs.png' alt='DOC'
                         className='doc-card-icon' />
                    <div className='doc-card-name'> {item.fileName
                      ? `${item.fileName.slice(0, 6)}...${item.fileName.slice(item.fileName.lastIndexOf('.'))}`
                      : 'Untitled'}</div>
                  </div>
                </>
              )
            })}
          </div>
        </div>
        {assessmentActivity && assessmentActivity.length ? assessmentActivity.map((item, index) => (
          <div key={index} className='d-flex flex-column'>
            {item.document && item.document.path && (
              <>
                <div className='d-flex justify-content-end '>
                  <a onClick={() => {
                    assEvents.openDocument(item.document.path)
                  }}
                     className='doc-bubble d-flex align-items-center pCursor'>
                    <div className='doc-image-section'>
                      <img src='../images/google-docs.png'
                           alt='doc'
                           className='doc-icon'
                      />
                    </div>
                    <div className='doc-text'>
                      <strong className='doc-filename'>
                        {item.document && item.document.fileName || 'Untitled.pdf'}
                      </strong>
                    </div>
                  </a>
                </div>


                <div className='d-flex justify-content-end mb-1' style={{ fontSize: '12px', color: '#888' }}>
                  {item.assignBy && item.assignBy.companyName && (
                    <div className='font-weight-bold'>
                      From {item.assignBy.companyName}
                    </div>
                  )}
                </div>
              </>
            )}

            {item.concern && (
              <>
                <div className='d-flex justify-content-start mb-1'>
                  <div className='p-3 rounded assessment_activity_card'>

                    <div style={{ fontSize: '14px', color: '#000' }}>
                      {item.concern}
                    </div>


                  </div>
                </div>
              </>
            )
            }

            {item.type == 'closed' ?
              <div className='d-flex justify-content-start mb-1'>
                <div className='p-3 rounded assessment_activity_card'>
                  {item.message}
                  <div className={`satisfied_text ${item.satisfied == 'satisfied' ? 'successText' : 'dangerText'}`}>
                    {item.satisfied} {' '}
                    {item.satisfied == 'satisfied' && '🙂'}
                    {item.satisfied == 'not satisfied' && '😔'}
                  </div>
                  {item.reason &&
                  <div>Reason : {item.reason}</div>
                  }
                </div>
              </div> : null
            }

            {item.type == 'callbackRequested' && (
              <>
                <div className='d-flex justify-content-start mb-1'>
                  <div className='p-3 rounded assessment_activity_card'>
                    <div style={{ fontSize: '14px', color: '#000' }}>
                      {item.message}{'\n'}
                      Status: {item.callbackId && item.callbackId.status == 'Pending' ? 'Open' : 'Close'}
                    </div>


                  </div>
                </div>
              </>
            )
            }
          </div>
        )) : null}
      </div>


      <div>
        {[...adminRightUser, 'branchUser'].includes(currentUser) && ['pending', 'viewed'].includes(singleAssessment && singleAssessment.status) ? (
          <>
            <div className={'ass-footer'} onClick={() => assEvents.showNotEligibleAssessmentDrawer()}>
              <a className='btn btn-success-dark xl roundNew2'>
                Not Eligible
              </a>
            </div>
          </>
        ) : null}
      </div>
      {addAssessmentVisible.visible ?
        <AddAssessment
          {...addAssessmentVisible}
          onClose={assEvents.hideAddAssessmentDrawer}
          onSubmit={() => {
            assEvents.hideAddAssessmentDrawer()
            assEvents.refreshData()
          }}
        /> : null}
      {addNotEligibleVisible.visible ?
        <NotEligibleAssessment
          {...addNotEligibleVisible}
          onClose={assEvents.hideNotEligibleAssessmentDrawer}
          onSubmit={() => {
            assEvents.hideNotEligibleAssessmentDrawer()
            assEvents.refreshData()
          }}
        /> : null}
    </Drawer>
  )
}
export default AssessmentProfile
